import axios from './axios';

export default (partnerProductId, siteId) =>
  axios.get(`/api/v2/products/${partnerProductId}/site/${siteId}`);
